import EnumCheckboxField from "../Fields/BaseInputFields/EnumCheckboxField/EnumCheckboxField";
import { CalendarField } from "../Fields/BaseInputFields/CalendarField/CalendarField";
import DateRangeField from "../Fields/BaseInputFields/DateRangeField/DateRangeField";
import EnumRadioField from "../Fields/BaseInputFields/EnumRadioField/EnumRadioField";
import BooleanRadioField from "../Fields/BaseInputFields/BooleanRadioField/BooleanRadioField";
import FileField from "../Fields/BaseInputFields/FileField/FileField";
import RichTextEditorField from "../Fields/BaseInputFields/RichTextEditorField/RichTextEditorField";
import SwitchField from "../Fields/BaseInputFields/SwitchField/SwitchField";
import TextAreaField from "../Fields/BaseInputFields/TextAreaField/TextAreaField";
import TextField from "../Fields/BaseInputFields/TextField/TextField";
import CustomField from "../Fields/CoreFields/CustomField/CustomField";
import ComplexField from "../Fields/CoreFields/ComplexField/ComplexField";
import { ReadOnlyField } from "../Fields/CoreFields/ReadOnlyField/ReadOnlyField";
import AsyncAutoCompleteField from "../Fields/DropdownFields/AsyncAutoCompleteField/AsyncAutoCompleteField";
import AsyncMultiselectField from "../Fields/DropdownFields/AsyncMultiSelectField/AsyncMultiselectField";
import EnumMultiSelectField from "../Fields/DropdownFields/EnumMultiSelectField/EnumMultiSelectField";
import { EnumSingleSelectFieldV2 } from "../Fields/DropdownFields/EnumSingleSelectFieldV2/EnumSingleSelectFieldV2";
import { SmartAddressField } from "../Fields/SpecialInputFields/SmartAddressField";
import { SimpleAddressField } from "../Fields/SpecialInputFields/SimpleAddressField";
import CurrencyField from "../Fields/SpecialInputFields/CurrencyField/CurrencyField";
import EmailField from "../Fields/SpecialInputFields/EmailField/EmailField";
import SignatureField from "../Fields/SpecialInputFields/SignatureField/SignatureField";
import SocialSecurityNumberField from "../Fields/SpecialInputFields/SocialSecurityField/SocialSecurityNumberField";
import SocialSecurityNumberV2Field from "../Fields/SpecialInputFields/SocialSecurityNumberV2Field/SocialSecurityNumberV2Field";
import EmployerIdentificationNumberField from "../Fields/SpecialInputFields/EmployerIdentificationNumberField/EmployerIdentificationNumberField";
import PhoneNumberField from "../Fields/SpecialInputFields/PhoneField/PhoneNumberField";
import { CoreFieldProps, FieldType } from "../Fields/types/fieldTypes";
import { SectionHeader } from "../Sections/SectionHeader";
import SingleCheckboxField from "../Fields/BaseInputFields/SingleCheckboxField/SingleCheckboxField";
import NumericField from "../Fields/BaseInputFields/NumericField/NumericField";
import { DateFieldV2 } from "../Fields/BaseInputFields/DateFieldV2/DateFieldV2";
import EnumMultiSelectFieldV2 from "../Fields/DropdownFields/EnumMultiSelectFieldV2/EnumMultiSelectFieldV2";
import { TagsField } from "../Fields/BaseInputFields/TagsField/TagsField";
import { ContactInformationField } from "../Fields/SpecialInputFields/ContactInformationField";
import AsyncODataDropdownField from "../Fields/DropdownFields/AsyncODataDropdownField/AsyncODataDropdownField";
import { NameField } from "../Fields/SpecialInputFields/NameField/NameField";
import AsyncMultiSelectTreeField from "../Fields/DropdownFields/AsyncMultiSelectTreeField/AsyncMultiSelectTreeField";
import { QueryBuilderField } from "../QueryBuilder/QueryBuilder";

export type FieldConfig = Record<
  FieldType,
  | Partial<React.FC<Partial<CoreFieldProps>>>
  | typeof CustomField
  | typeof ComplexField
>;

const systemFieldConfig: FieldConfig = {
  Text: TextField,
  SmartAddress: SmartAddressField,
  SimpleAddress: SimpleAddressField,
  SingleCheckbox: SingleCheckboxField,
  EnumCheckbox: EnumCheckboxField,
  Date: DateFieldV2,
  DateV2: DateFieldV2,
  Calendar: CalendarField,
  Email: EmailField,
  EnumRadio: EnumRadioField,
  BooleanRadio: BooleanRadioField,
  EnumSingleSelect: EnumSingleSelectFieldV2,
  AsyncAutoComplete: AsyncAutoCompleteField,
  EnumMultiSelect: EnumMultiSelectField,
  TextArea: TextAreaField,
  Signature: SignatureField,
  SocialSecurityNumber: SocialSecurityNumberField,
  SocialSecurityNumberV2: SocialSecurityNumberV2Field,
  EmployerIdentificationNumber: EmployerIdentificationNumberField,
  PhoneNumber: PhoneNumberField,
  Currency: CurrencyField,
  File: FileField,
  Switch: SwitchField,
  DateRange: DateRangeField,
  ReadOnly: ReadOnlyField,
  RichTextEditor: RichTextEditorField,
  AsyncMultiselect: AsyncMultiselectField,
  Section: SectionHeader,
  Numeric: NumericField,
  Custom: CustomField,
  Complex: ComplexField,
  EnumMultiSelectV2: EnumMultiSelectFieldV2,
  Tags: TagsField,
  ContactInformation: ContactInformationField,
  AsyncODataDropdown: AsyncODataDropdownField,
  Name: NameField,
  AsyncODataMultiSelectTree: AsyncMultiSelectTreeField,
  QueryBuilder: QueryBuilderField,
  Abstract: () => <></>,
};
export default systemFieldConfig;
